import { type Vector4Tuple } from "three";

export const randomColorInRange = (
  color1: Vector4Tuple,
  color2: Vector4Tuple,
) => {
  const step = Math.random();
  return [
    color1[0] * (1 - step) + color2[0] * step,
    color1[1] * (1 - step) + color2[1] * step,
    color1[2] * (1 - step) + color2[2] * step,
    color1[3] * (1 - step) + color2[3] * step,
  ] as Vector4Tuple;
};
